import LayersConfig from './LayersConfig';
import SourceConfig from './SourceConfig.js';
import LegislativeChoroplethStyleConfig from './LegislativeChoroplethStyleConfig';
import TractChoroplethStyleConfig from './TractChoroplethStyleConfig';
import TractVotingChoroplethStyleConfig from './TractVotingChoroplethStyleConfig';
import DemoArrayManager from '../DemographicData/DemoArrayManager';
import TractDemoArrayManager from '../DemographicData/TractDemoArrayManager';

import MobileDetect from 'mobile-detect';
import VotingPrecinctChoroplethStyleConfig from './VotingPrecinctChoroplethStyleConfig';

class Config {
    constructor() {

        this.experimentalFeatures = {
            print: true
        }
       
       //api keys and hostnames
        this.api = {
            hosts: {
                nodeHostAddress: process.env.VUE_APP_GIS_URL || 'https://dev.urbanresearchmaps.org/redistrict-api/v1', //process.env.VUE_APP_GIS_URL can be set from command line
                propublica: 'https://api.propublica.org'
            },
            keys: {
                ProPublicaAPIKey: 'QplHFUWxgN7DnRxoKBtlFaPQrDRfQPIn9vw8y9pQ',
                WillFMapboxKey: 'pk.eyJ1Ijoid2ZpZWxkLWN1bnkiLCJhIjoiY2p6YTJnN2lzMDB1aDNicm9qbzN6d2F5dCJ9.eOQlPpQf5uyOJANVWurDDA',
                CUNYMapBoxKey: 'pk.eyJ1IjoiY3VueWN1ciIsImEiOiJfQmNSMF9NIn0.uRgbcFeJbw2xyTUZY8gYeA',
                GoogleKey: 'AIzaSyBJvw79y0rr7YrcojtZOx9P7CtKk1pO1u8'
            },
        }

        //enums used throughout the app
        this.enums = {
            //Values must match postgres column names!
            LEG_BODY: {
                CONGRESS: 'congress',
                ST_LOWER: 'stateleglower',
                ST_UPPER: 'statelegupper'
            },
            //Each one corresponds to different api url endpoint. Value does NOT need to match with anything.
            DATA_SOURCE: {
                PROPUB: 'propublica',
                POSTGRES: 'postgres',
                POSTGRES_TILES: 'postgres-tiles',
                POSTGRES_FIPS_LABELS: 'postgres-fips-labels',
                MAPBOX: 'mapbox',
                ARCGIS_FEATURE_SERVER: 'arcgis-features'
            },
            //Values must match postgres column names!
            MAP_VARIABLES: {
                DEVIATION: 'deviation',
                POP: 'pop2020',
                POPCHG1020: 'popchg1020',
                POPCHGPCT1020: 'popchgpct1020'
                //POP: 'pop2019',
                //POPCHG1019: 'popchg1019',
                //POPCHGPCT1019: 'popchgpct1019'
                //,
                // CVAP: 'distcvap19pct',
                // NOTCVAP: 'distnotcvap19pct',
                //DEVIATIONCURRENT: 'deviationcurrent'
            },

            SIDE_TABS:{
                ONE_PERSON: 0,
                DEMOGRAPHICS: 1
            }
        }

        const md = new MobileDetect(window.navigator.userAgent);
        const isMobile = typeof (md.mobile() || md.phone()) === 'string';

        //For initializing the map. See layersConfig.js for individual layers
        this.map = {
            setup: {
                container: 'map',
                //style:'mapbox://styles/cunycur/ckost94py10iy17pe7hwntbwd',
                style:'mapbox://styles/cunycur/ckovkzv8q238x17pgdweoit7f',
                center: [-103, 38.5],
                zoom: 3.5,
                pitch: 0,
                hash: 'map',
                logoPosition: 'bottom-right',
                attributionControl: true,
                preserveDrawingBuffer: true,//this.experimentalFeatures.print && !isMobile,
                antialias: true // create the gl context with MSAA antialiasing, so custom layers are antialiased
            }
        }

        this.layersConfig = new LayersConfig(this); 
        this.sourceConfig = new SourceConfig(this);

        this.demoArrayManager = new DemoArrayManager(this);
        this.tractDemoArrayManager = new TractDemoArrayManager(this, 'cvap');
        this.tractVotingDemoArrayManager = new TractDemoArrayManager(this, 'vap');

        this.legislativeChoroplethStyleConfig = new LegislativeChoroplethStyleConfig();
        this.tractChoroplethStyleConfig = new TractChoroplethStyleConfig();
        this.tractVotingChoroplethStyleConfig = new TractVotingChoroplethStyleConfig();
        this.votingPrecinctSyleConfig = new VotingPrecinctChoroplethStyleConfig();
        

        //Labels for search fields, titles etc. in Vue templates (not for labels on the map itself)
        this.displayLabels = {
            bodies: {
                [this.enums.LEG_BODY.CONGRESS]: '117th Congress',
                [this.enums.LEG_BODY.ST_UPPER]: 'Upper State Legislature',
                [this.enums.LEG_BODY.ST_LOWER]: 'Lower State Legislature',
            },
            data: {
                // [this.enums.MAP_VARIABLES.DEVIATION]: this.layersConfig.layers.popDeviation.title, //This takes the label name from the layer title
                //[this.enums.MAP_VARIABLES.POP]: 'Population'//this.layersConfig.layers.pop2019.title //Can also be set manually (eg. 'Deviation' or 'Total Population')
            }
        }
    }

}

const _configInstance = new Config();

const Enums = _configInstance.enums;
const API = _configInstance.api;
const Map = _configInstance.map;
const Layers = _configInstance.layersConfig.layers;
const Sources = _configInstance.sourceConfig;
const LegislativeChoropleth = _configInstance.legislativeChoroplethStyleConfig;
const TractChoropleth = _configInstance.tractChoroplethStyleConfig;
const TractVotingChoropleth = _configInstance.tractVotingChoroplethStyleConfig;
const VotingChoropleth = _configInstance.votingPrecinctSyleConfig;
export {
    _configInstance as Config, Enums, API, Map, Layers, Sources, LegislativeChoropleth as LegislativeChoropleth, TractChoropleth, TractVotingChoropleth,
    VotingChoropleth
};